// extracted by mini-css-extract-plugin
export default {"wrapper":"confirmModal_wrapper__aLDYO","inside":"confirmModal_inside__S8mTu"};